"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHOTO_STYLES = void 0;
const frames_1 = require("./frames");
const matting_1 = require("./matting");
const filters_1 = require("./filters");
// frameColor, matting and filter are set only if they are common to all frames in wall
exports.PHOTO_STYLES = {
    classic: {
        id: 'classic',
        name: 'Classic',
        frameColor: frames_1.FRAME_COLORS.BLACK,
        matting: matting_1.MATTING.SHALLOW,
        filter: filters_1.FILTERS.NONE
    },
    ever: {
        id: 'ever',
        name: 'Ever',
        frameColor: frames_1.FRAME_COLORS.WHITE,
        matting: matting_1.MATTING.SHALLOW,
        filter: filters_1.FILTERS.NONE
    },
    bold: {
        id: 'bold',
        name: 'Bold',
        frameColor: frames_1.FRAME_COLORS.BLACK,
        matting: matting_1.MATTING.NONE,
        filter: filters_1.FILTERS.NONE
    },
    clean: {
        id: 'clean',
        name: 'Clean',
        frameColor: frames_1.FRAME_COLORS.WHITE,
        matting: matting_1.MATTING.NONE,
        filter: filters_1.FILTERS.NONE
    },
    edge: {
        id: 'edge',
        name: 'Edge',
        frameColor: frames_1.FRAME_COLORS.NONE,
        matting: matting_1.MATTING.NONE,
        filter: filters_1.FILTERS.NONE
    },
    mix: {
        id: 'mix',
        name: 'Mix',
        filter: filters_1.FILTERS.NONE
    },
    rustic: {
        id: 'rustic',
        name: 'Rustic',
        frameColor: frames_1.FRAME_COLORS.WOOD,
        filter: filters_1.FILTERS.NONE
    },
    earth: {
        id: 'earth',
        name: 'Earth',
        frameColor: frames_1.FRAME_COLORS.WOOD,
        matting: matting_1.MATTING.DEEP,
        filter: filters_1.FILTERS.NONE
    },
    romantic: {
        id: 'romantic',
        name: 'Romantic',
        frameColor: frames_1.FRAME_COLORS.BLACK,
        filter: filters_1.FILTERS.NOIR
    },
    silver: {
        id: 'silver',
        name: 'Silver',
        frameColor: frames_1.FRAME_COLORS.WOOD,
        matting: matting_1.MATTING.MEDIUM,
        filter: filters_1.FILTERS.SILVER
    },
    nordic: {
        id: 'nordic',
        name: 'Nordic',
        matting: matting_1.MATTING.MEDIUM,
        filter: filters_1.FILTERS.SILVER
    },
    lens: {
        id: 'lens',
        name: 'Lens',
        frameColor: frames_1.FRAME_COLORS.BLACK,
        matting: matting_1.MATTING.MEDIUM,
        filter: filters_1.FILTERS.NOIR
    },
    art: {
        id: 'art',
        name: 'Art',
        frameColor: frames_1.FRAME_COLORS.BLACK,
        matting: matting_1.MATTING.TOP,
        filter: filters_1.FILTERS.SILVER
    },
    elegant: {
        id: 'elegant',
        name: 'Elegant',
        frameColor: frames_1.FRAME_COLORS.BLACK,
        matting: matting_1.MATTING.DEEP,
        filter: filters_1.FILTERS.SILVER
    },
    natural: {
        id: 'natural',
        name: 'Natural',
        frameColor: frames_1.FRAME_COLORS.WOOD,
        matting: matting_1.MATTING.NONE,
        filter: filters_1.FILTERS.NONE
    },
    casual: {
        id: 'casual',
        name: 'Casual',
        frameColor: frames_1.FRAME_COLORS.WOOD,
        matting: matting_1.MATTING.SHALLOW,
        filter: filters_1.FILTERS.NONE
    },
    beach: {
        id: 'beach',
        name: 'Beach',
        frameColor: frames_1.FRAME_COLORS.WHITE,
        matting: matting_1.MATTING.SHALLOW,
        filter: filters_1.FILTERS.SILVER
    },
    stately: {
        id: 'stately',
        name: 'Stately',
        frameColor: frames_1.FRAME_COLORS.BLACK,
        matting: matting_1.MATTING.SHALLOW
    },
    mixed_styles: {
        id: 'mixed_styles',
        name: 'Mixed'
    }
};
//# sourceMappingURL=photoStyles.js.map